export default __webpack_public_path__ + "static/media/book-7.0075c474.jpeg";